// extracted by mini-css-extract-plugin
export var menuIcon = "_ql-0";
export var menuIconInline = "_ql-1";